import React from 'react'
import Layout from '../../components/Layout'

export default function Prijava() {

    return (
        <Layout>
            <main className="container px-6 font-medium text-lg text-primary">
                <h1 className="text-5xl mt-16 mb-8 lg:text-6xl lg:my-16 xl:text-7xl xl:my-20 mb-5">Pravila<span className="text-xs bg-primary px-2 py-1 text-white ml-2">COVID-19</span></h1>
                <nav className="mb-10 lg:-mt-10 xl:mb-20 lg:text-2xl lg:flex items-center">
                    <p>Pojdi na: </p>
                    <ul className="lg:flex">
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#splosne">Splošne določbe</a><span className="hidden lg:inline-block">, </span></li>
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#pogoji">Pogoji tekmovanja</a><span className="hidden lg:inline-block">, </span></li>
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#naloge">Naloge in ocenjevanje</a><span className="hidden lg:inline-block">, </span></li>
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#konec">Končne določbe</a></li>
                    </ul>
                </nav>
                <a className="border-b-2 border-yellow-500 font-semibold" href="https://drive.google.com/file/d/1hJYk_uQpY_nbB63uHr6EDzQVmX_ywOAQ/view?usp=sharing">
                    Pravila v PDF
                    <svg className="w-6 h-6 inline -mt-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clip-rule="evenodd"></path></svg>
                </a>
                <section className="mt-5 text-container">
                    <h2 id="splosne" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">Splošne določbe</h2>
                    <div className="flex mb-4">
                        <div className="mr-5">1.</div>
                        <p>
                            Zimsko orientacijsko tekmovanje (ZOT) organizira društvo tabornikov Rod XI. SNOUB Miloša Zidanška Maribor. Tekmovanje je enodnevno, poteka preko spleta z nalogami iz taborništva, orientacije in splošne razgledanosti.
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">2.</div>
                        <div>
                            <p>
                                Tekmovalci tekmujejo v dveh kategorijah:
                        </p>
                            <ul>
                                <li>100 – gozdovnice in gozdovniki</li>
                                <li>200 – popotnice in popotniki, raziskovalke in raziskovalci, grčice in grče.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">3.</div>
                        <div>
                            <p>
                                V kategoriji 100 kot najmlajši tekmujejo tekmovalci, ki v koledarskem letu, v katerem poteka tekmovanje, dopolnijo 12 let in kot najstarejši tekmovalci, ki v koledarskem letu, v katerem poteka tekmovanje, dopolnijo 15 let. En član ekipe je lahko eno leto mlajši ali starejši.
                        </p>
                            <p>V kategoriji 200 kot najmlajši tekmujejo tekmovalci, ki v koledarskem letu, v katerem poteka tekmovanje, dopolnijo 16 let. Navzgor ni omejitve. En član ekipe je lahko eno leto mlajši ali starejši.</p>
                        </div> 
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">4.</div>
                        <p>
                            Ekipa šteje največ 5 članov. Ekipa s štirimi člani lahko tekmuje brez olajšav. Ekipa s tremi ali manj člani tekmuje izven konkurence.</p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">5.</div>
                        <p>
                            Rod mora svoje ekipe prijaviti v roku, ki ga je določil organizator. Prijave potekajo preko spleta. Prijavnica se nahaja na uradni spletni strani tekmovanja. Brez oddane spletne prijavnice prijava ni veljavna.
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">6.</div>
                        <p>
                            Vsi tekmovalci tekmujejo na lastno odgovornost. Mladoletni tekmovalci morajo pred tekmovanjem po elektronski pošti poslati podpisano izjavo staršev, da so seznanjeni s potekom tekmovanja in da jim dovoljujejo udeležbo. Polnoletni tekmovalci morajo po elektronski pošti poslano izjavo o seznanjenosti s potekom tekmovanja in udeležbi na lastno odgovornost.
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">7.</div>
                        <p>
                            Vsi tekmovalci se obvezujejo, da se bodo v času tekmovanja obnašali po taborniških zakonih. V primeru kršenja predpisov, ki jih določi organizator, ali taborniških zakonov, bo ekipa diskvalificirana.
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">8.</div>
                        <p>
                            Tekmovalci sami odgovarjajo za svojo opremo. Rod XI. SNOUB ne prevzema odgovornosti za pozabljeno ali izgubljeno osebno opremo tekmovalcev.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">9.</div>
                        <p>
                            ZOT je potrebno razpisati vsaj en mesec pred začetkom tekmovanja.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">10.</div>
                        <p>
                            Razpis mora obsegati: kraj tekmovanja, čas tekmovanja, rok za prijavo, višino startnine, pogoje prijave in odjave, vračilo štartnin in druga, za tekmovanje pomembna obvestila.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">11.</div>
                        <p>
                            V kolikor organizator iz kateregakoli vzroka odpove ali preloži tekmovanje, mora o tem obvestiti vse prijavljene ekipe vsaj en dan pred tekmovanjem.
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">12.</div>
                        <p>
                            Tekmovanje vodi tekmovalna komisija, ki jo določi organizator. Pri izvedbi sodelujejo še sodniki in kontrolorji.
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">13.</div>
                        <p>
                            Ekipa se lahko zaradi nepravilnega sojenja, neizpolnjevanja tekmovalnih določil ali drugega vzroka pritoži. Pisno pritožbo je treba oddati najkasneje do razglasitve končnih rezultatov.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">14.</div>
                        <p>
                            V primeru pisne pritožbe se ustvari pritožbena komisija, ki jo sestavljajo: predstavnik organizatorja, član tekmovalne komisije in vodje prisotnih ekip, vendar največ eden iz vsake enote.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">15.</div>
                        <p>
                            Pritožbena komisija mora pritožbe preučiti ter zaslišati prizadete. Pritožba mora biti rešena pred razglasitvijo končnih rezultatov.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">16.</div>
                        <p>
                            Izide tekmovanja objavi tekmovalna komisija po prihodu vseh ekip na cilj oz. po izteku časa, ko bi morala priti na cilj še zadnja ekipa.
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">17.</div>
                        <p>
                            V času tekmovanja tolmači ta pravilnik tekmovalna komisija, pred in po tekmovanju pa rodova uprava Rodu XI. SNOUB Miloša Zidanška.
                        </p>
                    </div>

                </section>
                <section className="mt-5 text-container">
                    <h2 id="pogoji" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">Pogoji tekmovanja</h2>
                    <div className="flex mb-4">
                        <div className="mr-5">18.</div>
                        <p>
                            Štartno številko prejme ekipa najkasneje dan pred tekmovanjem.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">19.</div>
                        <p>
                            Vsaka ekipa mora izdelati vsaj en znak ekipe (npr. tabla, zastava, list papirja...) na katerem je napisana štartna številka ekipe in ime ekipe. Znak mora biti viden na vseh slikah in videoposnetkih, ki jih ekipa odda v ocenjevanje. Brez znaka se izdelek ne oceni.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">20.</div>
                        <p>
                            Organizator ekipi ni dolžan nuditi opreme za reševanje nalog.

                        </p>
                    </div>
                </section>
                <section className="mt-5 text-container">
                    <h2 id="naloge" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">Naloge in ocenjevanje</h2>
                    <div className="flex mb-4">
                        <div className="mr-5">21.</div>
                        <p>
                            Ekipa mora v 3h urah rešiti čim več nalog, ki jih zastavi organizator. Ekipa lahko opravlja več nalog naenkrat. Koliko članov rešuje posamezno nalogo, določi ekipa sama.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">22.</div>
                        <p>
                            Vrstni red opravljanja nalog je poljuben.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">23.</div>
                        <p>
                            Ekipa rešitve nalog odda preko spletne platforme in glede na navodila, rešitev odda v obliki fotografije, videoposnetka, sporočila ali rešenega vprašalnika (kviz).

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">24.</div>
                        <p>
                            Po pričetku tekmovanja ekipa dobi seznam nalog, ki jih lahko opravlja. Naloge preverjajo taborniško znanje ali pa so zabavne narave.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">25.</div>
                        <p>
                            Naloge obsegajo naslednje taborniške vsebine: orientacija in topografija (skica terena, orientacija, določitev koordinat, TOPO testi) in splošno taborniško znanje (npr. prva pomoč, vozli, signalizacija, pionirski objekti, znanje o naravi, taborniška oprema, Program za mlade, izumljanje in ustvarjanje). Priporočena literatura: Orientacija in topografija, Vozli in pionirski objekti, V naravo, Taborniška organizacija in Program za mlade.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">26.</div>
                        <p>
                            Naloge zabavne narave pa temeljijo na ustvarjalnosti, iznajdljivosti, različnih izzivih in nalogah splošne razgledanosti.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">27.</div>
                        <p>
                            Natančnejše opise nalog prejme ekipa skupaj z nalogami v času tekmovanja. Največje število točk, ki ga lahko ekipa prejme za opravljeno nalogo bo navedeno ob imenu naloge.

                        </p>
                    </div>
                </section>
                <section className="mt-5 text-container">
                    <h2 id="konec" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">Končne določbe</h2>
                    <div className="flex mb-4">
                        <div className="mr-5">28.</div>
                        <p>
                            V vsaki posamezni kategoriji zmaga ekipa, ki zbere največ točk. Prve tri ekipe v kategoriji prejmejo diplome. Če imata dve ekipi enako število točk, zmaga ekipa, ki dosega višje rezultate na teoretičnem delu nalog. Prvouvrščene ekipe prejmejo pokal ali praktične nagrade. V primeru, da prvouvrščene ekipe ne dosežejo 50% možnih točk, pokala oziroma nagrade ne dobijo.

                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">29.</div>
                        <p>
                            Propozicije potrjene na seji rodove uprave 9. 1. 2021.

                        </p>
                    </div>
                </section>
                <div className="fa-align-right mt-4">Rodova uprava, 9. 1. 2021
</div>
            </main>
        </Layout>
    );
}